"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const rangeParser = require("parse-numeric-range");
const markdown_widget_1 = require("./markdown-widget");
const markdown_code_block_1 = require("./markdown-code-block");
const ReactAddonsTextContent = require("react-addons-text-content");
class MarkdownPre extends React.Component {
    render() {
        const { props } = this;
        const [language] = getLanguages(props);
        const [highlights] = getHighlights(props);
        if (language === "widget") {
            return (React.createElement(markdown_widget_1.MarkdownWidget, { code: ReactAddonsTextContent(props.children) }));
        }
        return (React.createElement(markdown_code_block_1.MarkdownCodeBlock, { language: language, highlights: highlights }, props.children));
    }
}
exports.MarkdownPre = MarkdownPre;
function getLanguagePayload({ children }) {
    const child = children[0];
    if (!child) {
        return [];
    }
    const className = child.props.className;
    if (!className) {
        return [];
    }
    return className.split(" ").map(n => n.replace("language-", ""));
}
function getLanguages({ children }) {
    const payload = getLanguagePayload({ children })
        .map(n => n.replace(/\{[\d\-,\s]*\}$/, ""))
        .find(n => typeof n === "string" && n.length > 0);
    if (!payload) {
        return [];
    }
    return payload.split(":");
}
function getHighlights({ children }) {
    return getLanguagePayload({ children })
        .map(n => n.match(/\{([\d\-,\s]*)\}$/))
        .map(n => (n !== null ? n[1] : ""))
        .map(n => rangeParser.parse(n));
}
//# sourceMappingURL=markdown-pre.js.map